/*
 *
 * ManageProfilePage constants
 *
 */

export const DEFAULT_ACTION = 'app/ManageProfilePage/DEFAULT_ACTION';
